export default __webpack_public_path__ + "static/media/8.65ecb3f1.svg";